export const ANALYTICS_TREATMENT_GET = 'ANALYTICS_TREATMENT_GET';
export const ANALYTICS_TREATMENT_GET_SUCCESS = 'ANALYTICS_TREATMENT_GET_SUCCESS';
export const ANALYTICS_TREATMENT_GET_FAIL = 'ANALYTICS_TREATMENT_GET_FAIL';

export const ANALYTICS_TREATMENT_CLEAR = 'ANALYTICS_TREATMENT_CLEAR';
